export default __webpack_public_path__ + "static/transit-4f39abad5420f8a7236c417f4e6144da.jpg";